import React, { useState, useRef, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { nameregex, priceRegex, pecentageregex } from "../helper/regex";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import JoditEditor from "jodit-react";
import { posttravelPackage } from "../store/slices/tourpackage";
import { gettravelCategoryList } from "../store/slices/category";
import { getPlaceList } from "../store/slices/places";
import { CiCirclePlus, CiCircleMinus } from "react-icons/ci";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { GrUploadOption } from "react-icons/gr";
import { getroomType } from "../store/slices/roomType";
import { getFerryList } from "../store/slices/ferry";

const AddTourPackage = () => {
  const editor = useRef(null);
  let user = JSON.parse(localStorage.getItem("users"));
  const token = user.data.accessToken;
  const [categoryId, setcategoryId] = useState("");
  const [itineraryErrors, setItineraryErrors] = useState([]);
  const [hotelErrors, setHotelErrors] = useState([]);
  const [carRateErrors, setcarRateErrors] = useState([]);
  const [upperLimit, setupperLimit] = useState("");
  const [lowerLimit, setlowerLimit] = useState("");
  const [duration, setDuration] = useState("");
  const [places, setPlaces] = useState([]);
  const [category, setCategory] = useState([]);
  const [placeList, setplaceList] = useState([]);
  const [ferryList, setferryList] = useState([]);
  const [packageName, setpackageName] = useState("");
  const [packageRate, setpackageRate] = useState("");
  const [extrabedPrice, setextrabedPrice] = useState("");
  const [childPrice, setchildPrice] = useState("");
  const [ticketsPrice, setticketsPrice] = useState("");
  const [platformCharges, setplatformCharges] = useState("");
  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);
  const [imageError, setImageError] = useState("");
  const [inclusive, setInclusive] = useState("");
  const [exclusive, setExclusive] = useState("");
  const [roomTypeList, setroomTypeList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [roomRate, setroomRate] = useState([]);

  const stripHtmlTags = (html) => {
    return html.replace(/<[^>]*>/g, "").trim();
  };

  useEffect(() => {
    const nightsMatch = duration.match(/(\d+)\s+nights/);
    const nights = nightsMatch ? parseInt(nightsMatch[1], 10) : 0;
    setroomRate(
      Array.from({ length: nights }, (_, i) => ({ price: "", day: "" })),
    );
    setErrors(Array.from({ length: nights }, () => ({ price: "", day: "" })));
  }, [duration]);

  const handleRoomRateChange = (index, field, value) => {
    const updatedRates = [...roomRate];

    // Immutable update
    updatedRates[index] = {
      ...updatedRates[index],
      [field]: field === "price" ? value.replace(/\D/g, "").slice(0, 4) : value, // Allow only numbers for price
    };

    setroomRate(updatedRates);
    const updatedErrors = { ...errors };
    if (!updatedErrors[index]) {
      updatedErrors[index] = { price: "", day: "" };
    }

    if (field === "price") {
      if (value.trim() === "") {
        updatedErrors[index].price = "Price is required";
      } else if (isNaN(value)) {
        updatedErrors[index].price = "Price must be a number";
      } else {
        updatedErrors[index].price = "";
      }
    }

    if (field === "day" && value === "") {
      updatedErrors[index].day = "Please select a day";
    } else {
      updatedErrors[index].day = "";
    }

    setErrors(updatedErrors);
  };

  const [hotelDetails, sethotelDetails] = useState([
    {
      id: Date.now(),
      hotelName: "",
      place: "",
      duration: "",
      capacityPerRoom: "",
      starRating: "",
      roomType: "",
    },
  ]);

  const handleAddHotel = (e) => {
    e.preventDefault();
    sethotelDetails([
      ...hotelDetails,
      {
        id: Date.now(),
        hotelName: "",
        place: "",
        duration: "",
        capacityPerRoom: "",
        starRating: "",
        roomType: "",
      },
    ]);
    setHotelErrors([
      ...hotelErrors,
      {
        hotelName: "",
        place: "",
        duration: "",
        capacityPerRoom: "",
        starRating: "",
        roomType: "",
      },
    ]);
  };
  const handleRemoveHotel = (id) => {
    const updatedHotel = hotelDetails.filter((q) => q.id !== id);
    sethotelDetails(updatedHotel);

    const updatedErrors = hotelErrors.filter(
      (_, index) => hotelDetails[index].id !== id,
    );
    setHotelErrors(updatedErrors);
  };

  const handlehotelInputChange = (index, field, value) => {
    if (index >= hotelDetails.length) {
      console.error("Invalid index:", index);
      return;
    }

    const updatedHotel = [...hotelDetails];
    updatedHotel[index][field] = value;
    sethotelDetails(updatedHotel);

    const updatedErrors = [...hotelErrors];

    if (!updatedErrors[index]) {
      updatedErrors[index] = {
        hotelName: "",
        place: "",
        duration: "",
        capacityPerRoom: "",
        starRating: "",
        roomType: "",
      };
    }

    // Validate the fields
    if (field === "hotelName") {
      updatedErrors[index].hotelName =
        value.trim() === "" ? "Please enter hotel name" : "";
    }

    if (field === "place") {
      updatedErrors[index].place =
        value.trim() === "" ? "Please select place" : "";
    }

    if (field === "duration") {
      var sanitizedDuration = value.replace(/\D/g, "").slice(0, 1);
      updatedHotel[index].duration = sanitizedDuration;
      updatedErrors[index].duration =
        sanitizedDuration === "" || !pecentageregex.test(sanitizedDuration)
          ? "Please enter valid value"
          : "";
    }

    if (field === "capacityPerRoom") {
      var sanitizedcapacityPerRoom = value.replace(/\D/g, "").slice(0, 1);
      updatedHotel[index].capacityPerRoom = sanitizedcapacityPerRoom;
      updatedErrors[index].capacityPerRoom =
        sanitizedcapacityPerRoom === "" ||
        !pecentageregex.test(sanitizedcapacityPerRoom)
          ? "Please enter valid value"
          : "";
    }

    if (field === "starRating") {
      updatedErrors[index].starRating =
        value.trim() === "" ? "Please enter star rating" : "";
    }

    if (field === "roomType") {
      updatedErrors[index].roomType =
        value.trim() === "" ? "Please select room type" : "";
    }

    setHotelErrors(updatedErrors);
  };

  const [tourIternary, settourIternary] = useState([
    {
      id: Date.now(),
      title: "",
      description: "",
      breakfast: false,
      lunch: false,
      dinner: false,
      ferry: "",
    },
  ]);

  const handleAddItinerary = (e) => {
    e.preventDefault();

    settourIternary([
      ...tourIternary,
      {
        id: Date.now(),
        title: "",
        description: "",
        breakfast: false,
        lunch: false,
        dinner: false,
        ferry: "",
      },
    ]);

    setItineraryErrors([
      ...itineraryErrors,
      {
        title: "",
        description: "",
      },
    ]);
  };

  const handleRemoveItinerary = (id) => {
    const updatedItinerary = tourIternary.filter((q) => q.id !== id);
    settourIternary(updatedItinerary);

    const updatedErrors = itineraryErrors.filter(
      (_, index) => tourIternary[index].id !== id,
    );
    setItineraryErrors(updatedErrors);
  };

  const handleInputChange = (index, field, value) => {
    const updatedItinerary = [...tourIternary];
    updatedItinerary[index][field] = value;
    settourIternary(updatedItinerary);
    const updatedErrors = [...itineraryErrors];
    if (!updatedErrors[index]) {
      updatedErrors[index] = { title: "", description: "" };
    }

    if (field === "title") {
      updatedErrors[index].title =
        value.trim() === "" ? "Please enter title" : "";
    }
    if (field === "description") {
      updatedErrors[index].description =
        value.trim() === "" ? "Please enter description" : "";
    }

    setItineraryErrors(updatedErrors);
  };

  const handleCheckboxChange = (id, field) => {
    const updatedItinerary = tourIternary.map((q) =>
      q.id === id ? { ...q, [field]: !q[field] } : q,
    );
    settourIternary(updatedItinerary);
  };

  const [carRate, setcarRate] = useState([
    {
      id: Date.now(),
      minPax: "",
      maxPax: "",
      price: "",
    },
  ]);

  const handleAddCarRate = (e) => {
    e.preventDefault();
    setcarRate([
      ...carRate,
      {
        id: Date.now(),
        minPax: "",
        maxPax: "",
        price: "",
      },
    ]);
    setcarRateErrors([
      ...carRateErrors,
      {
        minPax: "",
        maxPax: "",
        price: "",
      },
    ]);
  };
  const handleRemoveCarRate = (id) => {
    const updatedcarRate = carRate.filter((q) => q.id !== id);
    setcarRate(updatedcarRate);

    const updatedErrors = carRateErrors.filter(
      (_, index) => carRate[index].id !== id,
    );
    setcarRateErrors(updatedErrors);
  };
  const handlecarRateInputChange = (index, field, value) => {
    if (index >= carRate.length) {
      console.error("Invalid index:", index);
      return;
    }

    const updatedcarRate = [...carRate];
    updatedcarRate[index][field] = value;
    setcarRate(updatedcarRate);

    const updatedErrors = [...carRateErrors];

    if (!updatedErrors[index]) {
      updatedErrors[index] = {
        minPax: "",
        maxPax: "",
        price: "",
      };
    }

    // Validate the fields
    if (field === "minPax") {
      var sanitizedPerson = value.replace(/\D/g, "").slice(0, 2);
      updatedcarRate[index].minPax = sanitizedPerson;
      updatedErrors[index].minPax =
        sanitizedPerson === "" || !pecentageregex.test(sanitizedPerson)
          ? "Please enter valid value"
          : "";
    }

    if (field === "maxPax") {
      var sanitizedPerson1 = value.replace(/\D/g, "").slice(0, 2);
      updatedcarRate[index].maxPax = sanitizedPerson1;
      updatedErrors[index].maxPax =
        sanitizedPerson1 === "" || !pecentageregex.test(sanitizedPerson1)
          ? "Please enter valid value"
          : "";
    }

    if (field === "price") {
      var sanitizedPerson3 = value.replace(/\D/g, "").slice(0, 5);
      updatedcarRate[index].price = sanitizedPerson3;
      updatedErrors[index].price =
        sanitizedPerson3 === "" || !priceRegex.test(sanitizedPerson3)
          ? "Please enter valid value"
          : "";
    }
    setcarRateErrors(updatedErrors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };
    let sanitizedPackageRate = packageRate;

    switch (name) {
      case "packageName":
        setpackageName(value);
        validationErrors[name] =
          value.trim() === "" || !nameregex.test(value)
            ? "Please enter valid package name"
            : "";
        break;

      case "categoryId":
        setcategoryId(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select category" : "";
        break;

      case "duration":
        setDuration(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select duration" : "";
        break;

      case "upperLimit":
        const sanitizedValue5 = value.replace(/\D/g, "").slice(0, 2);
        setupperLimit(sanitizedValue5);
        validationErrors[name] =
          sanitizedValue5 === "" || !pecentageregex.test(sanitizedValue5)
            ? "Please enter valid value"
            : "";
        break;

      case "lowerLimit":
        const sanitizedValue6 = value.replace(/\D/g, "").slice(0, 2);
        setlowerLimit(sanitizedValue6);
        validationErrors[name] =
          sanitizedValue6 === "" || !pecentageregex.test(sanitizedValue6)
            ? "Please enter valid value"
            : "";
        break;

      case "packageRate":
        sanitizedPackageRate = value.replace(/\D/g, "").slice(0, 6);
        setpackageRate(sanitizedPackageRate);
        validationErrors[name] =
          sanitizedPackageRate === "" || !priceRegex.test(sanitizedPackageRate)
            ? "Please enter valid price"
            : "";
        break;

      case "extrabedPrice":
        sanitizedPackageRate = value.replace(/\D/g, "").slice(0, 4);
        setextrabedPrice(sanitizedPackageRate);
        validationErrors[name] =
          value.trim() === "" || !priceRegex.test(sanitizedPackageRate)
            ? "Please enter valid extra bed price"
            : "";
        break;

      case "childPrice":
        sanitizedPackageRate = value.replace(/\D/g, "").slice(0, 4);
        setchildPrice(sanitizedPackageRate);
        validationErrors[name] =
          value.trim() === "" || !priceRegex.test(value)
            ? "Please enter valid child with bed price"
            : "";
        break;

      case "ticketsPrice":
        sanitizedPackageRate = value.replace(/\D/g, "").slice(0, 4);
        setticketsPrice(sanitizedPackageRate);
        validationErrors[name] =
          value.trim() === "" || !priceRegex.test(value)
            ? "Please enter valid ticket price"
            : "";
        break;

      case "platformCharges":
        sanitizedPackageRate = value.replace(/\D/g, "").slice(0, 4);
        setplatformCharges(sanitizedPackageRate);
        validationErrors[name] =
          value.trim() === "" || !priceRegex.test(value)
            ? "Please enter valid platform charges"
            : "";
        break;

      case "description":
        setDescription(value);
        if (errors.description && stripHtmlTags(value).length > 0) {
          setErrors((prevErrors) => ({ ...prevErrors, description: "" }));
        }
        break;

      case "inclusive":
        setInclusive(value);
        if (errors.inclusives && stripHtmlTags(value).length > 0) {
          setErrors((prevErrors) => ({ ...prevErrors, inclusive: "" }));
        }
        break;

      case "exclusive":
        setExclusive(value);
        if (errors.exclusive && stripHtmlTags(value).length > 0) {
          setErrors((prevErrors) => ({ ...prevErrors, exclusive: "" }));
        }
        break;

      default:
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        break;
    }

    setErrors(validationErrors);
  };

  const handlePlaceChange = (selectedOptions) => {
    const selectedPlaces = selectedOptions.map((option) => ({
      placeId: option._id,
      name: option.name,
    }));
    setPlaces(selectedPlaces);
    const isValid = selectedPlaces.length > 0;
    setErrors((prevErrors) => ({
      ...prevErrors,
      places: isValid ? "" : "Please select at least one place",
    }));
  };

  const scrollToError = () => {
    const firstErrorField = document.querySelector(".is-invalid");
    if (firstErrorField) {
      firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
      firstErrorField.focus();
    }
  };

  const validateForm = () => {
    let newErrors = {};

    roomRate.forEach((rate, index) => {
      if (!rate.price || rate.price.trim() === "") {
        newErrors[index] = { ...newErrors[index], price: "Price is required" };
      } else if (isNaN(rate.price)) {
        newErrors[index] = {
          ...newErrors[index],
          price: "Price must be a number",
        };
      }

      if (!rate.day || rate.day.trim() === "") {
        newErrors[index] = { ...newErrors[index], day: "Please select place" };
      }
    });

    if (!packageName.trim()) {
      newErrors.packageName = "Please enter package name";
    } else if (!nameregex.test(packageName)) {
      newErrors.packageName = "Please enter valid package name";
    }

    // Places Validation
    if (places.length === 0) {
      newErrors.places = "Please select at least one place";
    }

    // Category Validation
    if (!categoryId) {
      newErrors.categoryId = "Please select category";
    }

    if (!packageRate.trim()) {
      newErrors.packageRate = "Please enter package price";
    } else if (!priceRegex.test(packageRate)) {
      newErrors.packageRate = "Please enter valid price";
    }

    if (!extrabedPrice.trim()) {
      newErrors.extrabedPrice = "Please enter extra bed price";
    } else if (!priceRegex.test(extrabedPrice)) {
      newErrors.extrabedPrice = "Please enter valid price";
    }

    if (!childPrice.trim()) {
      newErrors.childPrice = "Please enter child with bed price";
    } else if (!priceRegex.test(childPrice)) {
      newErrors.childPrice = "Please enter valid price";
    }

    if (!ticketsPrice.trim()) {
      newErrors.ticketsPrice = "Please enter entry fees";
    } else if (!priceRegex.test(ticketsPrice)) {
      newErrors.ticketsPrice = "Please enter valid entry fees";
    }

    if (!platformCharges.trim()) {
      newErrors.platformCharges = "Please enter platform charges";
    } else if (!priceRegex.test(platformCharges)) {
      newErrors.platformCharges = "Please enter valid platform charges";
    }

    // Other Text Field Validations
    if (!description.trim() || stripHtmlTags(description).length === 0) {
      newErrors.description = "Please enter valid description";
    }

    if (!inclusive.trim() || stripHtmlTags(inclusive).length === 0) {
      newErrors.inclusive = "Please enter valid inclusion";
    }

    if (!exclusive.trim() || stripHtmlTags(exclusive).length === 0) {
      newErrors.exclusive = "Please enter valid exclusion";
    }

    // Image Validation
    if (images.length === 0) {
      newErrors.imageError = "Please upload at least one image";
      setImageError("Please upload at least one image");
    } else {
      setImageError(""); // Clear error if images exist
    }

    // Duration and Upper Limit Validation
    if (!duration) {
      newErrors.duration = "Please select duration";
    }

    if (!upperLimit) {
      newErrors.upperLimit = "Please enter upper limit";
    } else if (!pecentageregex.test(upperLimit)) {
      newErrors.upperLimit = "Please enter valid value";
    }

    if (!lowerLimit) {
      newErrors.lowerLimit = "Please enter lower limit";
    } else if (!pecentageregex.test(lowerLimit)) {
      newErrors.lowerLimit = "Please enter valid value";
    }

    // Itinerary Validation
    const itineraryErrors = tourIternary.map((item) => ({
      title: item.title.trim() === "" ? "Please enter title" : "",
      description:
        stripHtmlTags(item.description).length === 0
          ? "Please enter description"
          : "",
    }));

    setItineraryErrors(itineraryErrors);

    // Check for any itinerary errors
    if (itineraryErrors.some((err) => err.title || err.description)) {
      newErrors.tourIternary = "Please fix errors in the itinerary section";
    }

    const hotelErrors = hotelDetails.map((item) => ({
      hotelName: item.hotelName.trim() === "" ? "Please enter hotel name" : "",
      place: item.place.trim() === "" ? "Please select place" : "",
      duration: item.duration.trim() === "" ? "Please enter duration" : "",
      capacityPerRoom:
        item.capacityPerRoom.trim() === ""
          ? "Please enter capacity per room"
          : "",
      starRating:
        item.starRating.trim() === "" ? "Please enter star rating" : "",
      roomType: item.roomType.trim() === "" ? "Please enter room type" : "",
    }));

    setHotelErrors(hotelErrors);

    if (
      hotelErrors.some(
        (err) =>
          err.hotelName ||
          err.place ||
          err.duration ||
          err.capacityPerRoom ||
          err.starRating ||
          err.roomType,
      )
    ) {
      console.log("Hotel errors:", hotelErrors);
      newErrors.hotelDetails = "Please fix errors in the hotel section";
    }

    const carRateErrors = carRate?.map((item) => ({
      minPax: item.minPax.trim() === "" ? "Please enter min pax" : "",
      maxPax: item.maxPax.trim() === "" ? "Please enter max pax" : "",
      price: item.price.trim() === "" ? "Please enter price" : "",
    }));

    setcarRateErrors(carRateErrors);

    if (carRateErrors.some((err) => err.minPax || err.maxPax || err.price)) {
      console.log("Car rate errors:", carRateErrors);
      newErrors.carRate = "Please fix errors in the car rate section";
    }

    setErrors(newErrors);
    const isValid =
      Object.keys(newErrors).length === 0 &&
      itineraryErrors.every((err) => !err.title && !err.description) &&
      hotelErrors.every(
        (err) =>
          !err.hotelName &&
          !err.place &&
          !err.duration &&
          !err.capacityPerRoom &&
          !err.starRating &&
          !err.roomType,
      );

    // If form is invalid, scroll to the first error
    if (!isValid) {
      scrollToError();
    }

    return isValid;
  };
  const addPackage = async (e) => {
    e.preventDefault();
    setIsDisabled(true);

    setTimeout(() => setIsDisabled(false), 3000);

    if (!validateForm()) {
      console.log("Validation failed, please fix the errors.", errors);
      setIsDisabled(false);
      return;
    }
    const formattedRoomRate = [...roomRate].map((rate, index) => ({
      day: rate.day,
      price: parseFloat(rate.price),
    }));

    const hasInvalidFields = formattedRoomRate.some((rate, index) => {
      if (!rate.day || !rate.price) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [index]: {
            day: !rate.day ? "Day is required" : "",
            price: !rate.price ? "Price must be greater than 0" : "",
          },
        }));
        return true;
      }
      return false;
    });

    if (hasInvalidFields) {
      setIsDisabled(false);
      return;
    }

    const item = {
      categoryId,
      packageName,
      duration,
      inclusive,
      exclusive,
      isActive: 1,
      isApproved: 1,
      packageRate,
      extrabedPrice,
      childPrice,
      ticketsPrice,
      platformCharges,
      tourIternary,
      hotelDetails,
      roomRate: formattedRoomRate,
      carRate,
      upperLimit,
      lowerLimit,
      isSpecial: 0,
      places,
      description,
      images: images,
    };

    try {
      await dispatch(posttravelPackage(item)).unwrap();
      alert("Travel package added successfully!");
      navigate("/admin/tour-package");
    } catch (error) {
      alert(error);
      setIsDisabled(false);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  const imageUpload = async (e) => {
    setImageError("");
    const files = Array.from(e.target.files);

    if (files.length === 0) {
      setImageError("Please select at least one file to upload");
      return;
    }
    if (images.length + files.length > 10) {
      setImageError("You can upload a maximum 10 images");
      return;
    }

    const newImage = [];
    for (let file of files) {
      if (file.size > 5 * 1024 * 1024) {
        setImageError("Please upload image less than 5 MB");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          "x-access-token": token,
        },
      };

      try {
        const response = await fetch(
          `${API_BASE_URL}${API_PATHS.uploadFile}`,
          requestOptions,
        );

        if (!response.ok) {
          throw new Error(`Upload failed with status: ${response.status}`);
        }

        const data = await response.json();

        if (data?.status === 1 && data?.data?.location) {
          newImage.push({
            name: file.name,
            mediaLink: data.data.location,
            isActive: true,
          });
        } else {
          throw new Error(data.message || "Failed to upload image");
        }
      } catch (error) {
        setImageError(
          error.message || "Something went wrong while uploading the image",
        );
        return;
      }
    }

    setImages((prevImage) => [...prevImage, ...newImage]);
    e.target.value = null;
  };

  useEffect(() => {
    console.log("Updated images state:", images);
  }, [images]);

  const removeImage = (index) => {
    setImages((prevImage) => {
      const updatedImage = [...prevImage];
      updatedImage.splice(index, 1);

      if (updatedImage.length === 0) {
        setImageError("Please upload at least one image");
      } else {
        setImageError("");
      }

      return updatedImage;
    });
  };

  const editorConfig = useMemo(
    () => ({
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "align",
        "font",
        "fontsize",
        "paragraph",
        "|",
        "undo",
        "redo",
      ],
      placeholder: "Enter Description",
      removeButtons: ["image", "video", "file", "speech", "print", "preview"],
      readonly: false,
    }),
    [],
  );

  const itineraryEditorConfig = useMemo(
    () => ({
      height: 180,
      toolbarAdaptive: false,
      buttons: ["bold", "italic", "|", "ul", "ol", "|", "undo", "redo"],
      placeholder: "Enter itinerary details",
      removeButtons: [
        "image",
        "video",
        "file",
        "speech",
        "print",
        "preview",
        "fontsize",
        "font",
      ],
    }),
    [],
  );

  React.useEffect(() => {
    dispatch(gettravelCategoryList())
      .unwrap()
      .then((data) => {
        setCategory(data?.categoryData || []);
      })
      .catch((err) => {
        console.error("Error fetching category:", err.message);
      });
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(getPlaceList())
      .unwrap()
      .then((data) => {
        setplaceList(data?.placesData || []);
      })
      .catch((err) => {
        console.error("Error fetching places:", err.message);
      });
  }, [dispatch]);
  React.useEffect(() => {
    dispatch(getFerryList())
      .unwrap()
      .then((data) => {
        setferryList(data?.ferryData);
      })
      .catch(({ message }) => console.error(message));
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const roomTypeData = await dispatch(getroomType()).unwrap();
        const serializedRoomTypeData = roomTypeData;
        setroomTypeList(serializedRoomTypeData);
      } catch (err) {
        console.error("Error fetching data:", err.message);
      }
    };
    fetchData();
  }, [dispatch]);
  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Add Package</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/tour-package"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Packages
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Add Package</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form autoComplete="off" onSubmit={addPackage}>
            <div className="row mb-40">
              <div className="col-md-5">
                <label className="form-label">
                  Package Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="packageName"
                  value={packageName}
                  maxLength={150}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.packageName ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Package Name"
                />
                {errors.packageName && (
                  <div className="text-danger mt-2">{errors.packageName}</div>
                )}
              </div>
              <div className="col-md-5">
                <label className="form-label">
                  Package Category <span className="text-danger">*</span>
                </label>
                <select
                  name="categoryId"
                  value={categoryId}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.categoryId ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Select</option>
                  {category?.map((catdata) => (
                    <option key={catdata._id} value={catdata._id}>
                      {catdata.categoryName}
                    </option>
                  ))}
                </select>
                {errors.categoryId && (
                  <div className="text-danger mt-2">{errors.categoryId}</div>
                )}
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Places<span className="text-danger">*</span>
                </label>
                <Typeahead
                  id="basic-typeahead-multiple"
                  labelKey="name"
                  multiple
                  className="input1"
                  onChange={handlePlaceChange}
                  options={placeList}
                  placeholder="Select Places"
                  selected={placeList.filter((place) =>
                    places.some(
                      (selectedPlace) => selectedPlace.placeId === place._id,
                    ),
                  )}
                />
                {errors.places && (
                  <div className="text-danger mt-2">{errors.places}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Duration <span className="text-danger">*</span>
                </label>
                <select
                  name="duration"
                  value={duration}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.duration ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Select</option>
                  <option value="3 nights 4 days">3 nights 4 days</option>
                  <option value="4 nights 5 days">4 nights 5 days</option>
                  <option value="5 nights 6 days">5 nights 6 days</option>
                  <option value="6 nights 7 days">6 nights 7 days</option>
                  <option value="7 nights 8 days">7 nights 8 days</option>
                  <option value="8 nights 9 days">8 nights 9 days</option>
                  <option value="9 nights 10 days">9 nights 10 days</option>
                  <option value="10 nights 11 days">10 nights 11 days</option>
                  <option value="11 nights 12 days">11 nights 12 days</option>
                  <option value="12 nights 13 days">12 nights 13 days</option>
                  <option value="13 nights 14 days">13 nights 14 days</option>
                  <option value="14 nights 15 days">14 nights 15 days</option>
                </select>
                {errors.duration && (
                  <div className="text-danger mt-2">{errors.duration}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Upper Limit <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="upperLimit"
                  value={upperLimit}
                  placeholder="Enter Upper Limit"
                  onChange={handleChange}
                  className={`form-control ${
                    errors.upperLimit ? "is-invalid" : ""
                  }`}
                />

                {errors.upperLimit && (
                  <div className="text-danger mt-2">{errors.upperLimit}</div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Lower Limit <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="lowerLimit"
                  value={lowerLimit}
                  placeholder="Enter Lower Limit"
                  onChange={handleChange}
                  className={`form-control ${
                    errors.lowerLimit ? "is-invalid" : ""
                  }`}
                />

                {errors.lowerLimit && (
                  <div className="text-danger mt-2">{errors.lowerLimit}</div>
                )}
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Room Rates <span className="text-danger">*</span>
                </label>
                <div className="container border p-3 mb-3 rounded">
                  <div className="row">
                    {roomRate.map((rate, index) => (
                      <div
                        key={index}
                        className="col-md-3 m-3 p-3"
                        style={{
                          border: "solid 1px silver",
                          borderRadius: "5px",
                        }}
                      >
                        <select
                          value={rate.day}
                          className="form-control"
                          onChange={(e) =>
                            handleRoomRateChange(index, "day", e.target.value)
                          }
                        >
                          <option value="">Place</option>
                          <option value="PB">PB</option>
                          <option value="Hav">Hav</option>
                          <option value="Neil">Neil</option>
                          <option value="Long-Island ">Long-Island</option>
                          <option value="Baratang">Baratang</option>
                          <option value="Rangat">Rangat</option>
                          <option value="Mayabunder">Mayabunder</option>
                          <option value="Diglipur">Diglipur</option>
                          <option value="Hut Bay">Hut Bay</option>
                        </select>
                        {errors[index]?.day && (
                          <span className="error-message text-danger">
                            {errors[index].day}
                          </span>
                        )}

                        <input
                          type="text"
                          placeholder={`Room Price`}
                          value={rate.price}
                          onChange={(e) =>
                            handleRoomRateChange(index, "price", e.target.value)
                          }
                          className="form-control border rounded p-2 mt-3"
                        />

                        {errors[index]?.price && (
                          <span className="error-message text-danger">
                            {errors[index].price}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Car Rates <span className="text-danger">*</span>
                </label>
                <div className="question-form">
                  {carRate?.map((item, index) => (
                    <div
                      key={item.id}
                      className="container border p-3 mb-3 rounded"
                    >
                      {/* Button Alignment */}
                      <div className="d-flex justify-content-end mb-2">
                        <button
                          className="btn btn-primary-600  me-2"
                          onClick={handleAddCarRate}
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                        >
                          <CiCirclePlus style={{ fontSize: "25px" }} />
                        </button>
                        <button
                          className="btn btn-outline-primary-600"
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                          onClick={() => handleRemoveCarRate(item.id)}
                          disabled={carRate.length === 1}
                        >
                          <CiCircleMinus style={{ fontSize: "25px" }} />
                        </button>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-4">
                          <label className="form-label">
                            Min Pax <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter Min Pax"
                            value={item.minPax}
                            onChange={(e) =>
                              handlecarRateInputChange(
                                index,
                                "minPax",
                                e.target.value,
                              )
                            }
                            className="form-control"
                          />
                          {carRateErrors[index]?.minPax && (
                            <span className="error-message">
                              {carRateErrors[index]?.minPax}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">
                            Max Pax
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter Max Pax"
                            value={item.maxPax}
                            onChange={(e) =>
                              handlecarRateInputChange(
                                index,
                                "maxPax",
                                e.target.value,
                              )
                            }
                            className="form-control"
                          />
                          {carRateErrors[index]?.maxPax && (
                            <span className="error-message">
                              {carRateErrors[index]?.maxPax}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">
                            Price
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter Min Pax"
                            value={item.price}
                            onChange={(e) =>
                              handlecarRateInputChange(
                                index,
                                "price",
                                e.target.value,
                              )
                            }
                            className="form-control"
                          />
                          {carRateErrors[index]?.price && (
                            <span className="error-message">
                              {carRateErrors[index]?.price}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Package Price <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="packageRate"
                  value={packageRate}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.packageRate ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Price"
                />
                {errors.packageRate && (
                  <div className="text-danger mt-2">{errors.packageRate}</div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Extra Bed Price <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="extrabedPrice"
                  value={extrabedPrice}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.extrabedPrice ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Extra Bed Price"
                />
                {errors.extrabedPrice && (
                  <div className="text-danger mt-2">{errors.extrabedPrice}</div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Chil With Bed Price <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="childPrice"
                  value={childPrice}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.childPrice ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Child With Bed Price"
                />
                {errors.childPrice && (
                  <div className="text-danger mt-2">{errors.childPrice}</div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Entry Fees <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="ticketsPrice"
                  value={ticketsPrice}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.ticketsPrice ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Entry Fees"
                />
                {errors.ticketsPrice && (
                  <div className="text-danger mt-2">{errors.ticketsPrice}</div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Platform Charges (Per Person)
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="platformCharges"
                  value={platformCharges}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.platformCharges ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Platform Charges"
                />
                {errors.platformCharges && (
                  <div className="text-danger mt-2">
                    {errors.platformCharges}
                  </div>
                )}
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Images <span className="text-danger">*</span>
                </label>
                <br />
                <label for="fileInput" className="custom-button">
                  <GrUploadOption
                    style={{ fontSize: "16px", lineHeight: "18px" }}
                  />
                  &nbsp; Upload Image
                </label>
                <input
                  type="file"
                  id="fileInput"
                  name="image"
                  accept="image/*"
                  onChange={imageUpload}
                  className={`form-control ${imageError ? "is-invalid" : ""}`}
                  multiple
                />

                {imageError && (
                  <div className="text-danger mt-2">{imageError}</div>
                )}
                <div className="row mt-3">
                  {images.map((img, index) => (
                    <div
                      className="col-md-2 mb-2 position-relative"
                      key={index}
                    >
                      <img
                        src={img.mediaLink}
                        style={{ height: "120px", objectFit: "cover" }}
                        alt=""
                        className="img-thumbnail"
                      />
                      <button
                        className="image-remove-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          removeImage(index);
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Description <span className="text-danger">*</span>
                </label>

                <JoditEditor
                  ref={editor}
                  value={description}
                  onChange={(newContent) => {
                    setDescription(newContent);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      description:
                        !newContent.trim() ||
                        stripHtmlTags(newContent).length === 0
                          ? "Please enter valid description"
                          : "",
                    }));
                  }}
                  config={editorConfig}
                />

                {errors.description && (
                  <div className="text-danger mt-2">{errors.description}</div>
                )}
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Itinerary <span className="text-danger">*</span>
                </label>
                <div className="question-form">
                  {tourIternary.map((item, index) => (
                    <div
                      key={item.id}
                      className="container border p-3 mb-3 rounded"
                    >
                      <div className="d-flex justify-content-end mb-2">
                        <button
                          className="btn btn-primary-600  me-2"
                          onClick={handleAddItinerary}
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                        >
                          <CiCirclePlus style={{ fontSize: "25px" }} />
                        </button>
                        <button
                          className="btn btn-outline-primary-600"
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                          onClick={() => handleRemoveItinerary(item.id)}
                          disabled={tourIternary.length === 1}
                        >
                          <CiCircleMinus style={{ fontSize: "25px" }} />
                        </button>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-10">
                          <label className="form-label">
                            Title <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter title"
                            value={item.title}
                            onChange={(e) =>
                              handleInputChange(index, "title", e.target.value)
                            }
                            className="form-control"
                          />
                          {itineraryErrors[index]?.title && (
                            <span className="error-message">
                              {itineraryErrors[index]?.title}
                            </span>
                          )}
                        </div>
                        <div className="col-md-6 mt-3">
                          <label className="form-label">
                            Ferry Service
                            {/* <span className="text-danger">*</span> */}
                          </label>

                          <select
                            name="ferry"
                            value={item.ferry}
                            onChange={(e) =>
                              handleInputChange(index, "ferry", e.target.value)
                            }
                            className={`form-control ${
                              errors.ferry ? "is-invalid" : ""
                            }`}
                          >
                            <option value="">Select</option>
                            {ferryList?.map((ferrydata) => (
                              <option key={ferrydata._id} value={ferrydata._id}>
                                {ferrydata.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-2 mt-5">
                          <div className="form-switch switch-purple d-flex align-items-center gap-3">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="switch4"
                              checked={item.breakfast}
                              onChange={() =>
                                handleCheckboxChange(item.id, "breakfast")
                              }
                            />
                            <label
                              className="form-check-label line-height-1 fw-medium text-secondary-light"
                              htmlFor="switch4"
                            >
                              Breakfast
                            </label>
                          </div>
                        </div>
                        <div className="col-md-2 mt-5">
                          <div className="form-switch switch-success d-flex align-items-center gap-3">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="switch4"
                              checked={item.lunch}
                              onChange={() =>
                                handleCheckboxChange(item.id, "lunch")
                              }
                            />
                            <label
                              className="form-check-label line-height-1 fw-medium text-secondary-light"
                              htmlFor="switch4"
                            >
                              Lunch
                            </label>
                          </div>
                        </div>
                        <div className="col-md-2 mt-5">
                          <div className="form-switch switch-warning d-flex align-items-center gap-3">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="switch4"
                              checked={item.dinner}
                              onChange={() =>
                                handleCheckboxChange(item.id, "dinner")
                              }
                            />
                            <label
                              className="form-check-label line-height-1 fw-medium text-secondary-light"
                              htmlFor="switch4"
                            >
                              Dinner
                            </label>
                          </div>
                        </div>
                        <div className="col-md-12 mt-3">
                          <label className="form-label">
                            Details <span className="text-danger">*</span>
                          </label>
                          <JoditEditor
                            value={item.description}
                            config={itineraryEditorConfig}
                            onChange={(newContent) =>
                              handleInputChange(
                                index,
                                "description",
                                newContent,
                              )
                            }
                          />

                          {itineraryErrors[index]?.description && (
                            <span className="error-message">
                              {itineraryErrors[index]?.description}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Hotel Details <span className="text-danger">*</span>
                </label>
                <div className="question-form">
                  {hotelDetails.map((item, index) => (
                    <div
                      key={item.id}
                      className="container border p-3 mb-3 rounded"
                    >
                      {/* Button Alignment */}
                      <div className="d-flex justify-content-end mb-2">
                        <button
                          className="btn btn-primary-600  me-2"
                          onClick={handleAddHotel}
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                        >
                          <CiCirclePlus style={{ fontSize: "25px" }} />
                        </button>
                        <button
                          className="btn btn-outline-primary-600"
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                          onClick={() => handleRemoveHotel(item.id)}
                          disabled={hotelDetails.length === 1}
                        >
                          <CiCircleMinus style={{ fontSize: "25px" }} />
                        </button>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-4">
                          <label className="form-label">
                            Hotel Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter hotel name"
                            value={item.hotelName}
                            onChange={(e) =>
                              handlehotelInputChange(
                                index,
                                "hotelName",
                                e.target.value,
                              )
                            }
                            className="form-control"
                          />
                          {hotelErrors[index]?.hotelName && (
                            <span className="error-message">
                              {hotelErrors[index]?.hotelName}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">
                            Hotel Location
                            <span className="text-danger">*</span>
                          </label>

                          <select
                            name="place"
                            value={item?.place}
                            onChange={(e) =>
                              handlehotelInputChange(
                                index,
                                "place",
                                e.target.value,
                              )
                            }
                            className={`form-control ${
                              errors.locality ? "is-invalid" : ""
                            }`}
                          >
                            <option value="">Select</option>
                            {placeList?.map((placedata) => (
                              <option
                                key={placedata._id}
                                value={placedata.name}
                              >
                                {placedata.name}
                              </option>
                            ))}
                          </select>
                          {hotelErrors[index]?.place && (
                            <span className="error-message">
                              {hotelErrors[index]?.place}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">
                            Star Rating
                            <span className="text-danger">*</span>
                          </label>

                          <select
                            name="starRating"
                            value={item.starRating}
                            onChange={(e) =>
                              handlehotelInputChange(
                                index,
                                "starRating",
                                e.target.value,
                              )
                            }
                            className={`form-control ${
                              errors.starRating ? "is-invalid" : ""
                            }`}
                          >
                            <option value="">Select</option>
                            <option value="Apartment">Apartment</option>
                            <option value="2 Star">2 Star</option>
                            <option value="2 Star Budget">2 Star Budget</option>
                            <option value="3 Star Budget">3 Star Budget</option>
                            <option value="3 Star Standard">
                              3 Star Standard
                            </option>
                            <option value="3 Star Premium">
                              3 Star Premium
                            </option>
                            <option value="3 Star Deluxe">3 Star Deluxe</option>
                            <option value="4 Star Standard">
                              4 Star Standard
                            </option>
                            <option value="4 Star Deluxe">4 Star Deluxe</option>
                            <option value="4 Star">4 Star</option>
                            <option value="5 Star">5 Star</option>
                            <option value="Home Stay">Home Stay</option>
                            <option value="H/ Stay-Sea-F">H/ Stay-Sea-F</option>
                          </select>
                          {hotelErrors[index]?.starRating && (
                            <span className="error-message">
                              {hotelErrors[index]?.starRating}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4 mt-3">
                          <label className="form-label">
                            Duration <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter duration"
                            value={item.duration}
                            onChange={(e) => {
                              const value = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 1);
                              handlehotelInputChange(index, "duration", value);
                            }}
                            className="form-control"
                          />

                          {hotelErrors[index]?.duration && (
                            <span className="error-message">
                              {hotelErrors[index]?.duration}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4 mt-3">
                          <label className="form-label">
                            Room Type
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            value={item.roomType}
                            onChange={(e) =>
                              handlehotelInputChange(
                                index,
                                "roomType",
                                e.target.value,
                              )
                            }
                            className="form-control"
                          >
                            <option value="">Select</option>
                            {roomTypeList?.roomTypeData?.map((catdata) => (
                              <option key={catdata._id} value={catdata.name}>
                                {catdata.name}
                              </option>
                            ))}
                          </select>
                          {hotelErrors[index]?.roomType && (
                            <span className="error-message">
                              {hotelErrors[index]?.roomType}
                            </span>
                          )}
                        </div>

                        <div className="col-md-4 mt-3">
                          <label className="form-label">
                            Room Capacity <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter capacity per room"
                            value={item.capacityPerRoom}
                            onChange={(e) =>
                              handlehotelInputChange(
                                index,
                                "capacityPerRoom",
                                e.target.value,
                              )
                            }
                            className="form-control"
                          />
                          {hotelErrors[index]?.capacityPerRoom && (
                            <span className="error-message">
                              {hotelErrors[index]?.capacityPerRoom}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Inclusion <span className="text-danger">*</span>
                </label>

                <JoditEditor
                  ref={editor}
                  value={inclusive}
                  onChange={(newContent) => {
                    setInclusive(newContent);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      inclusive:
                        !newContent.trim() ||
                        stripHtmlTags(newContent).length === 0
                          ? "Please enter valid inclusion"
                          : "",
                    }));
                  }}
                  config={editorConfig}
                />

                {errors.inclusive && (
                  <div className="text-danger mt-2">{errors.inclusive}</div>
                )}
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Exclusion <span className="text-danger">*</span>
                </label>

                <JoditEditor
                  ref={editor}
                  value={exclusive}
                  onChange={(newContent) => {
                    setExclusive(newContent);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      exclusive:
                        !newContent.trim() ||
                        stripHtmlTags(newContent).length === 0
                          ? "Please enter valid exclusion"
                          : "",
                    }));
                  }}
                  config={editorConfig}
                />

                {errors.exclusive && (
                  <div className="text-danger mt-2">{errors.exclusive}</div>
                )}
              </div>
              {/* <div className="col-md-10 mt-3">
                <label className="form-label">
                  Terms and Conditions <span className="text-danger">*</span>
                </label>

                <JoditEditor
                  ref={editor}
                  value={termsCondition}
                  onChange={(newContent) => {
                    settermsCondition(newContent);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      termsCondition:
                        !newContent.trim() ||
                        stripHtmlTags(newContent).length === 0
                          ? "Please enter valid terms and condition"
                          : "",
                    }));
                  }}
                  config={editorConfig}
                />

                {errors.termsCondition && (
                  <div className="text-danger mt-2">
                    {errors.termsCondition}
                  </div>
                )}
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Payment Policy <span className="text-danger">*</span>
                </label>
                <JoditEditor
                  ref={editor}
                  value={paymentPolicy}
                  onChange={(newContent) => {
                    setpaymentPolicy(newContent);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      paymentPolicy:
                        !newContent.trim() ||
                        stripHtmlTags(newContent).length === 0
                          ? "Please enter valid payment policy"
                          : "",
                    }));
                  }}
                  config={editorConfig}
                />

                {errors.paymentPolicy && (
                  <div className="text-danger mt-2">{errors.paymentPolicy}</div>
                )}
              </div> */}
              {/* <div className="col-md-10 mt-3">
                <label className="form-label">
                  Cancel Policy <span className="text-danger">*</span>
                </label>

                <JoditEditor
                  ref={editor}
                  value={cancellationPolicy}
                  onChange={(newContent) => {
                    setcancellationPolicy(newContent);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      cancellationPolicy:
                        !newContent.trim() ||
                        stripHtmlTags(newContent).length === 0
                          ? "Please enter valid cancel policy"
                          : "",
                    }));
                  }}
                  config={editorConfig}
                />

                {errors.cancellationPolicy && (
                  <div className="text-danger mt-2">
                    {errors.cancellationPolicy}
                  </div>
                )}
              </div> */}
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddTourPackage;
